import { render, staticRenderFns } from "./AppNavbarEmbed.vue?vue&type=template&id=1cafa886&scoped=true&"
import script from "./AppNavbarEmbed.vue?vue&type=script&lang=js&"
export * from "./AppNavbarEmbed.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarEmbed.vue?vue&type=style&index=0&id=1cafa886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cafa886",
  null
  
)

export default component.exports